import React from 'react';
import style from './MembershipSteps.module.scss';
import Done from 'common/icons/done_v2.svg';

const MembershipSteps: React.FC<{
    current: number;
    titles: string[];
}> = ({ current, titles }) => {
    return (
        <div className={style.stepsGrid}>
            {[0, 1, 2].map((stepIndex) => {
                const isActive = current === stepIndex;
                const isCompleted = current > stepIndex;

                return (
                    <React.Fragment key={stepIndex}>
                        <div className={style.step}>
                            <div
                                className={`${style.circle} ${
                                    isActive ? style.active : ''
                                } ${isCompleted ? style.completed : ''}`}>
                                {isCompleted ? (
                                    <img src={Done} alt='Done' />
                                ) : (
                                    stepIndex + 1
                                )}
                            </div>
                            {isActive && (
                                <span className={style.stepTitle}>
                                    {titles[stepIndex]}
                                </span>
                            )}
                        </div>

                        {stepIndex < 2 && (
                            <div
                                className={`${style.line} ${
                                    (stepIndex === 0 && current === 0) ||
                                    (stepIndex === 1 &&
                                        (current === 1 || current === 2))
                                        ? style.lineActive
                                        : ''
                                }`}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default MembershipSteps;
